module.exports = __webpack_public_path__ + "static/media/posta_poruba_8_(2).43339944.jpg";